__turbopack_context__.v({
  "arrowDown": "_EJ0Pq_arrowDown",
  "button": "_EJ0Pq_button",
  "buttonsContainer": "_EJ0Pq_buttonsContainer",
  "crossIcon": "_EJ0Pq_crossIcon",
  "dialog": "_EJ0Pq_dialog",
  "dialogBody": "_EJ0Pq_dialogBody",
  "divider": "_EJ0Pq_divider",
  "label": "_EJ0Pq_label",
  "text": "_EJ0Pq_text",
});
